import { render, staticRenderFns } from "./BadGe.vue?vue&type=template&id=efb74fb6"
import script from "./BadGe.vue?vue&type=script&lang=js"
export * from "./BadGe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports